import AOS from "aos";
import "aos/dist/aos.css";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { bindActionCreators } from "redux";
import "./home.scss";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { Button } from "@material-ui/core";

function Home(props) {
	AOS.init({
		delay: 500,
		once: true
	});
	return (
		<div className="sec4 sec3-1">
			<div className="container">
				<div className="sec4Head">
					<h2 className="title" data-aos="">
					GGILab: Your Gateway to Gemological Excellence
					</h2>
					<p data-aos="" data-aos-easing="linear" className="labSec4Text">
					Are you intrigued by the captivating world of gemstones? GGILab, a leading gemological institute in Pakistan, offers a comprehensive range of services to meet your needs. Our state-of-the-art laboratory and experienced gemologists ensure accurate and reliable gemstone testing and certification.
					</p>

					{/* <div className=""> */}
					<h2 className="title" data-aos="">
						Our Services
					</h2>
					{/* </div> */}
					<div className="ServiceHomeDiv">

						<div className="ServiceHome">
							<h5 data-aos="">Gem Lab Testing</h5>
							<p data-aos="" data-aos-easing="linear" className="labSec4Text">
							Unravel the mysteries of gemstones with our advanced testing techniques. From identification to grading, we provide detailed reports to ensure authenticity and quality.
							</p>
						</div>
						<div className="ServiceHome">
							<h5 data-aos="">Online Gemology Certification</h5>
							<p data-aos="" data-aos-easing="linear" className="labSec4Text">
							Become a certified gemologist through our convenient online courses. Learn from industry experts and gain the knowledge to excel in the field.
							</p>
						</div>
						<div className="ServiceHome">
							{/* <h5 data-aos="fade-up">Gemology Certification Online</h5>
							<p data-aos="fade-down" data-aos-easing="linear" className="labSec4Text">
								Embark on a journey of gemology with our online certification courses. Learn about gem identification, grading, and the fascinating world of gemstones through interactive and engaging modules.
							</p> */}
						</div>
					</div>


					{/* <div className=""> */}
					<h2 className="title" data-aos="">
					Why Choose GGILab?
					</h2>
					{/* </div> */}
					<div className="ServiceHomeDiv">

						<div className="ServiceHome">
							<h5 data-aos="">Trusted Expertise</h5>
							<p data-aos="" data-aos-easing="linear" className="labSec4Text">
							Our team of experienced gemologists is committed to providing accurate and unbiased assessments							</p>
						</div>
						<div className="ServiceHome">
							<h5 data-aos="">Cutting-Edge Technology</h5>
							<p data-aos="" data-aos-easing="linear" className="labSec4Text">
							 We utilize the latest technology to ensure precise and reliable results.
							</p>
						</div>
						<div className="ServiceHome">
							<h5 data-aos="">Global Recognition</h5>
							<p data-aos="" data-aos-easing="linear" className="labSec4Text">
							As part of Global Gemological Laboratories and Global Gems International Laboratories, we maintain international standards.
							</p>
						</div>
						<div className="ServiceHome">
							<h5 data-aos="">Convenient Online Services</h5>
							<p data-aos="" data-aos-easing="linear" className="labSec4Text">
							Access our online courses and gemstone identification tools from anywhere in the world							</p>
						</div>
					</div>


					{/* <div className=""> */}
					<h2 className="title" data-aos="">
					Visit Our Laboratories:
					</h2>
					{/* </div> */}
					

						<div className="ServiceHome">
							<p data-aos="" data-aos-easing="linear" className="labSec4Text">
							<span style={{ color: "black" ,fontsize:"18px",}}>Karachi:
								
								</span>   Explore our state-of-the-art laboratory in Karachi for comprehensive gemstone testing and certification.
							</p>
							<p data-aos="" data-aos-easing="linear" className="labSec4Text">
						<b  style={{ color: "black"}}>Peshawar:</b>	 Discover our gem and mineral testing laboratory in Peshawar, where we specialize in identifying and analyzing minerals								</p>
						</div>
						<div className="ServiceHome">
							<p data-aos="" data-aos-easing="linear" className="labSec4Text">
							Join us on a journey of gemological discovery. Contact us today to learn more about our services and how we can assist you
							</p>
							</div>
							<br/>
					<center>		<Link to="/contact-us">
							<button
     style={{
        backgroundColor:'rgb(0, 0, 0)', // Bright call-to-action color
        outline: 'none',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', // Subtle shadow to make the button pop
        boxSizing: 'border-box',
        height: 'auto',
        width: 'auto',
        color: 'rgb(255, 255, 255)', // White text for contrast
        textDecoration: 'none',
        whiteSpace: 'nowrap',
        textAlign: 'center', // Center text for CTA
        lineHeight: '24px',
        letterSpacing: '1px',
        fontWeight: 700,
        fontSize: '16px', // Slightly larger font size for CTA
        borderColor: 'transparent',
        padding: '15px 40px', // Increased padding for a bigger button
        transformOrigin: 'center',
        opacity: 1,
        visibility: 'visible',
        borderWidth: '0px',
        borderRadius: '8px', // Rounded edges for a modern look
        borderStyle: 'none',
        transition: 'background-color 0.3s ease, color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease', // Smooth transitions for color, transform, and shadow
      }}
      onMouseEnter={(e) => {
        e.target.style.backgroundColor = '#d52a25'; 
        e.target.style.color = 'rgb(255, 255, 255)'; 
        e.target.style.transform = 'scale(1.08)'; 
        e.target.style.boxShadow = '0px 8px 16px rgba(0, 0, 0, 0.2)'; // Increase shadow on hover
      }}
      onMouseLeave={(e) => {
        e.target.style.backgroundColor = 'rgb(0, 0, 0)'; // Revert background color
        e.target.style.color = 'rgb(255, 255, 255)'; // Keep text color white
        e.target.style.transform = 'scale(1)'; // Revert size
        e.target.style.boxShadow = '0px 4px 12px rgba(0, 0, 0, 0.1)'; // Revert shadow
      }}
    >
Book a Consultation						</button>
					</Link></center>

				</div>
			</div>
		</div>
	);
}

const mapStateToProps = ({ store }) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Home));



